import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

import styles from "./sidebar.module.css";

import UpgradeModal from "../upgradenow/upgradenow";
import { useCookies } from "../../../../hooks/useCookies";
import { useUserProfile } from "../context/UserProfileContext";
import { getProfileImageUrl } from "../../../../utils/serverUtils";
import { useAppContext } from '../../../../Context/UseContext';


export default function Suggestions({ Rejected }) {
  const { profiles } = useUserProfile();
  const [show, setShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const cookies = useCookies();
  const { isPremium } = useAppContext();


  const handleClose = () => setModalShow(false);

  const ShowfullList = () => {
    if (cookies.getCookie("approval") === "PENDING") {
      setModalShow(true);
    }

    if (!Rejected) {
      if (isPremium !== true) {
        setShow(true);
      } else {
        navigate("/user/recommendations");
      }
    }
  };

  return (
    <div className={styles.suggestions} style={{ borderTop: "2px solid #e0e0e0" }}>
      <div>
        <p style={{ fontSize: "16px" }}>Suggested for you</p>
        <p style={{ cursor: "pointer", fontSize: "16px" }} onClick={ShowfullList}>See All</p>
      </div>

      {!Rejected &&
        Array.isArray(profiles) &&
        profiles.slice(0, 3).map((profile, index) => (
          <div
            key={`${profile.id}-${index}`}
            id={`${profile.id}-${index}`}
            style={{
              display: "flex",
              gap: "1rem",
              width: "100%",
              alignItems: "center",
              justifyContent: "flex-start",
              padding: "10px",
            }}
            onClick={() =>
              navigate(`/user/${profile.first_name}/${profile.user_id}`)
            }
          >
            <img
              src={getProfileImageUrl(profile)}
              alt={"profile"}
              width={70}
              height={70}
              style={{
                borderRadius: "9999px",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                alignItems: "flex-start",
                justifyContent: "center",
                color: "#515151",
              }}
            >
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "1rem",
                  marginBottom: "-0.5rem",
                }}
              >
                {profile.first_name}
              </p>
              <p>Suggested for you</p>
            </div>
          </div>
        ))}
      <UpgradeModal show={show} setShow={setShow} />

      {/* Modal for See All data of Profile */}
      <Modal className="customer-modal-without-header-footer" show={modalShow} onHide={handleClose} centered>
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <Modal.Body style={{ padding: "25px" }}>
          <h5>Your account has not been activated</h5>
        </Modal.Body>
      </Modal>
    </div>
  );
}
